module.exports = __webpack_public_path__ + "static/laptop_stroz-d5ce88a9a92bc3c2a8ae2dbe3f10de30.png";